module.exports = __webpack_public_path__ + "img/yl.e9f90f60.svg";